import { apiClient } from "lib/apiClient";

export interface ITransaction {
  transactionId: string;
  walletId: string;
  createdBy: string;
  userId: string;
  type: string;
  coins: number;
  compType: string;
  compId: string;
  compName: string;
  companyId: string;
  propertyId: string;
  creationDate: string;
}

export type ITransactions = {
  totalBalance: number;
  walletTransactions: ITransaction[];
};

export const getTransactionHistory = async (
  id: string
): Promise<ITransactions> => {
  const response = await apiClient.get(`/wallets/transactions/${id}`);

  return response.data;
};
